export const formattedMonth = (dataString) => {
  const monthDate = new Date(dataString);
  return `${new Intl.DateTimeFormat('en-US', { month: 'long' }).format(monthDate)}-${monthDate.getFullYear()}`;
};
export const formattedDate = (dateString) => {
  const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
  return new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));
};

export const minutesToHHMMSS = (minutes) => {
  let hours = Math.floor(minutes / 60);
  let remainingMinutes = minutes % 60;
  if (hours === 0) hours = "00";
  if (remainingMinutes === 0) remainingMinutes = "00";
  return `${hours}: ${remainingMinutes}: 00`;
}
export const generateAppropriateDate = (value) => {
  if (value === undefined || value === null) {
    return 'N/A';
  } else {
    const date = new Date(value);
    /*const formattedDate =
      (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()) +
      '-' +
      (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
      '-' +
      date.getFullYear() +
      ' ' +
      (date.getHours() % 12 || 12) +
      ':' +
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ' ' +
      (date.getHours() >= 12 ? 'PM' : 'AM');*/

    const formattedDate = [
        ('0' + date.getDate()).slice(-2), // Day
        ('0' + (date.getMonth() + 1)).slice(-2), // Month
        date.getFullYear(), // Year
    ].join('-') + ' ' + date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });

    return formattedDate;
  }
};

export const generateAppropriateDateWithConsent = (value) => {
  if (value === undefined || value === null) {
    return 'N/A';
  } else {
    const date = new Date(value);
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  }
};

export function formatStringDate(postDate) {
  // Parse the provided array into a Date object
  const date = new Date(...postDate);

  // Format the date into a human-readable string
  //const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
  const formattedDate = [
      ('0' + date.getDate()).slice(-2), // Day
      ('0' + (date.getMonth() + 1)).slice(-2), // Month
      date.getFullYear(), // Year
  ].join('-') + ' ' + date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });

  return formattedDate;
}

export const convertDateFormatTo24H = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

export const sortDashboardData = (data, sortOrder = 'descending') => {
  // Ensure data is provided and is an array
  if (!Array.isArray(data)) {
    console.error('Invalid data provided.');
    return [];
  }

  // Sort data based on date
  data.sort((a, b) => {
    const dateA = new Date(formattedDate(a.createDate));
    const dateB = new Date(formattedDate(b.createDate));

    if (sortOrder === 'ascending') {
      return dateA - dateB;
    } else {
      return dateB - dateA;
    }
  });

  return data;
};

export function getMonthYearString(timestamp) {
  const date = new Date(timestamp);
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
}
